import { render, staticRenderFns } from "./Tetris.vue?vue&type=template&id=52e9f358&scoped=true&"
import script from "./Tetris.vue?vue&type=script&lang=js&"
export * from "./Tetris.vue?vue&type=script&lang=js&"
import style0 from "./Tetris.vue?vue&type=style&index=0&id=52e9f358&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e9f358",
  null
  
)

export default component.exports